<template>
  <!-- 用户中心 -->
  <div class="container">
    <div class="row" @click="goToInfo()">
      <div class="left-row">
        <img class="img-style" src="@/assets/user_info_img.png" />
        <span class="text-style">个人信息</span>
      </div>
      <img class="arrow-style" src="@/assets/arrow_right.png" />
    </div>

    <div class="line"></div>

    <div class="row" @click="goToOrder()">
      <div class="left-row">
        <img class="img-style" src="@/assets/user_order_img.png" />
        <span class="text-style">我的订单</span>
      </div>
      <img class="arrow-style" src="@/assets/arrow_right.png" />
    </div>

    <div class="line"></div>

    <template v-if="orderList.length">
      <div class="row" @click="goFreeOrder()">
        <div class="left-row">
          <img class="img-style" src="@/assets/depositFree.png" />
          <span class="text-style">免押订单</span>
        </div>
        <img class="arrow-style" src="@/assets/arrow_right.png" />
      </div>

      <div class="line"></div>
    </template>

    <div class="row" @click="enterCoupon">
      <div class="left-row">
        <img class="img-style" src="@/assets/user_coupon.png" />
        <span class="text-style">优惠券</span>
      </div>
      <div class="right-row">
        <span class="coupon-text">{{ couponCount }}张</span>
        <img class="arrow-style" src="@/assets/arrow_right.png" />
      </div>
    </div>

    <div class="line"></div>

    <div v-if="appData.customerPhone" class="row" @click="callPhone()">
      <div class="left-row">
        <img class="img-style" src="@/assets/user_customer.png" />
        <span class="text-style">联系客服</span>
      </div>
      <div class="right-row">
        <span class="coupon-text">{{ appData.customerPhone }}</span>
        <img class="arrow-style" src="@/assets/arrow_right.png" />
      </div>
    </div>

    <div class="line"></div>

    <div class="row" @click="goToAgreement()">
      <div class="left-row">
        <img class="img-style" src="@/assets/user_agreement.png" />
        <span class="text-style">协议条款</span>
      </div>
      <img class="arrow-style" src="@/assets/arrow_right.png" />
    </div>

    <div class="line"></div>

    <div class="row" @click="goToAboutUs()">
      <div class="left-row">
        <img class="img-style" src="@/assets/user_aboutus.png" />
        <span class="text-style">关于我们</span>
      </div>
      <img class="arrow-style" src="@/assets/arrow_right.png" />
    </div>
  </div>
</template>

<script>
import { getListofUnsecuredOrders, getCouponList } from "@/api/user";

export default {
  components: {},
  data() {
    return {
      orderList: [], //免押订单
      couponCount: 0,
    };
  },

  mounted() {
    this.getFreeList(); //免押
    this.getListAction();//优惠券
  },

  methods: {
    goToInfo() {
      this.uni.navigateTo("/user/info");
    },
    goToOrder() {
      this.uni.navigateTo("/user/order");
    },
    goToAgreement() {
      this.uni.navigateTo("/user/agreement");
    },
    goToAboutUs() {
      this.uni.navigateTo("/user/aboutus");
    },
    callPhone() {
      window.location.href = "tel:" + this.appData.customerPhone;
    },

    goFreeOrder() {
      this.uni.navigateTo("/user/freeOrder");
    },

    getFreeList() {
      getListofUnsecuredOrders()
        .then((res) => {
          console.log(res);
          this.orderList = res.list ? res.list : [];
          console.log("获取列表成功", res);
        })
        .catch((err) => {
          console.error("获取列表失败：" + err);
        });
    },


    /*获取可用优惠券数量*/
    getListAction() {
      const params = {
        index: this.pageIndex,
        pageSize: this.pageSize,
        couponStatus: 1, //可用
      };

      getCouponList(params)
        .then((res) => {
          this.couponCount = res.count;
        });
    },

    enterCoupon() {
      this.uni.navigateTo("/coupon/mangerCoupons");
      // this.uni.navigateTo("/coupon/claimCoupon?t=1&o=2013925325211774977");
    }
  },
};
</script>

<style lang="less" scoped>
.container {
  background: white;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;

  .line {
    width: 100%;
    height: 1px;
    background: #f0f0f0;
  }

  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 34px;
    padding-bottom: 34px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .left-row {
    display: flex;
    align-items: center;
  }

  .img-style {
    width: 40px;
    height: 40px;
  }

  .text-style {
    font-size: 32px;
    color: #24262b;
    margin-left: 20px;
  }

  .arrow-style {
    width: 36px;
    height: 36px;
  }

  .coupon-text {
    font-size: 32px;
    color: var(--primary-color);
    margin-right: 8px;
  }

  .right-row {
    display: flex;
    align-items: center;
  }
}
</style>
